import { Link } from "react-router-dom";
import { routes } from "@/routes/routes";
import { chatCopy } from "../engine/copy";

// Consents asked inside the chat, the terms one tap away.
const preliminaryIntro = (
  <>
    Pentru oferta preliminară, trebuie să facem o verificare la Biroul de
    Credit, <strong>fără impact asupra scorului tău.</strong>
  </>
);

const bcAndAnafQuestion = (
  <>
    Ești de acord să îți verificăm datele la{" "}
    <Link to={routes.terms.bc}>Biroul de Credit</Link> și{" "}
    <Link to={routes.terms.anaf}>ANAF</Link>?
  </>
);

// Before the preliminary offer: both consents in one answer.
export const preliminaryConsentLines = [preliminaryIntro, bcAndAnafQuestion];

// Asked again inside the BC score when the BC consent is missing.
export const bcConsentLines = [
  preliminaryIntro,
  <>
    Ești de acord să îți verificăm datele la{" "}
    <Link to={routes.terms.bc}>Biroul de Credit</Link>?
  </>,
];

export const termsConsentLines = [chatCopy.terms[0], bcAndAnafQuestion];

// A returning user whose offers expired.
export const renewalConsentLines = [...chatCopy.offerRenewal, bcAndAnafQuestion];

export const anafConsentLines = [
  chatCopy.anafConsent[0],
  <>
    Ești de acord să îți verificăm datele la{" "}
    <Link to={routes.terms.anaf}>ANAF</Link>?
  </>,
];
